import { BundleComponent } from "@tm/morpheus"
import { ModuleGroup } from "./component"

const ModuleGroupBundle: BundleComponent = {
    name: "module-group",
    component: ModuleGroup,
}

export { ModuleGroup, ModuleGroupBundle }
